import client from './client';

export async function list(params = {}) {
  const { data } = await client.get('/api/incidents', { params });
  return data;
}

export async function get(id) {
  const { data } = await client.get(`/api/incidents/${id}`);
  return data;
}

export async function assign(id, assignedUserId) {
  const { data } = await client.patch(`/api/incidents/${id}/assign`, { assignedUserId });
  return data;
}

export async function setStatus(id, status, resolutionNote) {
  const { data } = await client.patch(`/api/incidents/${id}/status`, { status, resolutionNote });
  return data;
}

export async function addNote(id, note) {
  const { data } = await client.post(`/api/incidents/${id}/notes`, { note });
  return data;
}
